import { h, Fragment } from "preact";
import { useState, useContext, useEffect } from "preact/hooks";
import { Box, Button, Grid, Paper, Stack, Tooltip, Typography } from "@mui/material";
import EuroIcon from '@mui/icons-material/Euro';
import NumberField from "../Common/NumberField";
import CardTemplate from "../Common/CardTemplate";
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";
import PriceBreakdown2 from "./PriceBreakdown2";
import palette from "../../theme/palette";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { AppContext } from "../../AppContext";
export default function PriceCard({ actualDeal, mode }) {
    const [localState, setLocalState] = useState({});
    const app = useContext(AppContext);
    const handleChange = (event) => {

        setLocalState({ ...localState, [event.target.name]: event.target.value });
    };
    const handleSubmitChangePrice = () => {

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ price: localState.price }),
        };
        fetch("/api/495e843c2f424afa9c3c4a3f0e6b6753/" + actualDeal.deal_uid, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":

                        window.location.reload();

                        break;

                    case "err":
                        break;
                    default:
                        break;
                }
            });
    };
    // useEffect(() => {
    //     const requestOptions = {
    //         method: "GET",
    //         headers: { "Content-Type": "application/json" },
    //     };
    //     fetch("/api/finsettings", requestOptions)
    //         .then((response) => {
    //             return response.json();
    //         })
    //         .then((res) => {
    //             switch (res.res) {
    //                 case "ok":
    //                     setLocalState((state) => ({
    //                         ...state, settings: res.pld
    //                     }));

    //                     break;
    //                 case "err":
    //                     break;
    //                 default:
    //                     break;
    //             }
    //         });
    // }, []);
    console.log("localState", localState)
    return (
        <CardTemplate
            title="Prix"
            buttons={<Fragment>
                {((mode == "V" && actualDeal.idp && !actualDeal.oabs) || (mode == "A" && !actualDeal.mandate)) && <ButtonWithTooltipAndBadge
                    tooltip="Fixer le prix"
                    icon={<EuroIcon />}
                    onclick_cb={
                        () => {
                            if (actualDeal.mandate) {
                                app.refPopUp.current.handleChangeState(
                                    {
                                        opened: true,
                                        type: "002",
                                        params: {
                                            title: "Attention",
                                            body: (
                                                <div>
                                                    <Typography variant="body1" gutterBottom>
                                                        Le mandat de vente a été émis, si vous modifiez le prix,
                                                    </Typography>
                                                    <Typography variant="body1" gutterBottom>
                                                        un avenant au mandat devra être signé.
                                                    </Typography>
                                                    <Typography variant="h5" gutterBottom>
                                                        Voulez-vous vraiment changer le prix ?
                                                    </Typography>
                                                </div>
                                            ),
                                            yes_action: () => {
                                                setLocalState({ ...localState, price_beeing_fixed: true });
                                                app.refPopUp.current.handleChangeState(
                                                    {
                                                        opened: false
                                                    }
                                                );
                                            }
                                        }
                                    })
                            } else {
                                setLocalState({ ...localState, price_beeing_fixed: true });
                            }
                        }
                    }
                    badge={(!localState.price_beeing_fixed && (actualDeal.price_num === 0))} />}
            </Fragment>}

            content={
                <Fragment>
                    {!localState.price_beeing_fixed && <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box  >
                            {((actualDeal.price_num === 0)) && (<em>Pas de prix fixé</em>)}
                            {((actualDeal.price_num > 0)) && (<Typography variant="h5">Prix net vendeur {actualDeal.agreed_price ? (actualDeal.agreed_price - actualDeal.bkeys_fee).toString().match(/(\d+?)(?=(\d{3})+(?!\d)|$)/g).join(" ") : actualDeal.price}&nbsp;€</Typography>)}
                        </Box>
                        <Box p={1}>
                            {((actualDeal.price_num > 0)) && (

                                <CheckCircleIcon
                                    style={{
                                        color: palette.success.main,
                                    }}
                                />

                            )}
                        </Box>
                    </Box>
                    }

                    {
                        localState.price_beeing_fixed && (<Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Box p={1}>
                                    <NumberField value={localState.price} onChange={handleChange} id="price" />
                                </Box>
                                <Box  >
                                    <Button
                                        variant="contained"

                                        onClick={handleSubmitChangePrice}>Fixer le prix</Button>
                                </Box>
                            </Box>
                        </Stack>)
                    }

                    {(localState.price !== undefined || actualDeal.price_num > 0) &&
                        <PriceBreakdown2
                            prix_net_vendeur={localState.price ? localState.price : actualDeal.price_num}
                            prix_public={localState.agreed_price ? localState.agreed_price : actualDeal.agreed_price}
                            bk_fees={localState.bkeys_fee ? localState.bkeys_fee : actualDeal.bkeys_fee}
                            settings={actualDeal.finsettings}

                        />}
                </Fragment>
            }
        />)



}
